// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-container {
  width: 100%;
  height: 750px;
  background-color: white;
  padding: 16px;
  margin: 0;
  box-sizing: border-box;
}

@media (max-width: 992px) {
  .onboarding-container {
    width: 100%;
    padding: 12px;
    border-left: none;
  }
}

.pricing-model-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 100%;
  height: auto;
  padding-right: 8px;
  box-sizing: border-box;
  gap: 1rem;
  /* padding-right: 0.5rem; */
  padding: 0px;
}

.table-scroll {
  overflow-x: auto; /* horizontal scroll only if needed */
  overflow-y: auto; /* vertical scroll if needed */
  max-width: 100%;
}

@media (max-width: 992px) {
  .pricing-model-container {
    padding-right: 0;
    gap: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Onboarding.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,gBAAgB,EAAE,qCAAqC;EACvD,gBAAgB,EAAE,8BAA8B;EAChD,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;IAChB,SAAS;EACX;AACF","sourcesContent":[".onboarding-container {\n  width: 100%;\n  height: 750px;\n  background-color: white;\n  padding: 16px;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n@media (max-width: 992px) {\n  .onboarding-container {\n    width: 100%;\n    padding: 12px;\n    border-left: none;\n  }\n}\n\n.pricing-model-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  padding-right: 8px;\n  box-sizing: border-box;\n  gap: 1rem;\n  /* padding-right: 0.5rem; */\n  padding: 0px;\n}\n\n.table-scroll {\n  overflow-x: auto; /* horizontal scroll only if needed */\n  overflow-y: auto; /* vertical scroll if needed */\n  max-width: 100%;\n}\n\n@media (max-width: 992px) {\n  .pricing-model-container {\n    padding-right: 0;\n    gap: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
